import Splide from '@splidejs/splide';
import { getBreakpointOptions, setContentHeight } from './sliderLayout';
import { pubSub } from '@utils/PubSub';
export default class Slider {
  constructor(context) {
    this.module = context;
    this.arrows = [
      context.querySelector('.splide__arrow--prev'),
      context.querySelector('.splide__arrow--next'),
    ];
    this.splide = context.querySelector('.splide');
    const showArrows =
      context.classList.contains('visual-category') &&
      context
        .querySelector('.splide[data-show-arrows]')
        ?.getAttribute('data-show-arrows') == 'false'
        ? false
        : true;
    this.options = {
      type: this.getLayoutType(context),
      lazyLoad: false,
      perMove: 1,
      arrows: showArrows,
      preloadPages: 2,
      role: 'group',
      mediaQuery: 'min',
      focus: 0,
      omitEnd: true,
    };

    this.init();
  }
  init() {
    const initOptions = this.getSplideOptions(),
      { id } = this.splide,
      splide = new Splide(`#${id}`, initOptions);

    this.splide = splide || this.splide;
    this.splide.on('mounted', () => {
      this.splide.options = initOptions;
      this.splide.root
        .querySelector('.splide__list')
        .setAttribute('role', 'group');
      setContentHeight(this.splide.root);
    });

    this.splide.mount();

    // Make SVG's accessible for sliders that do not experience mutations on
    // initial page load, then observe for the ones that do.
    this.improveSVGAccessibility();
    this.observeForAccessibility();
  }

  getLayoutType(context) {
    let type;
    const isVisualCategory = context.classList.contains('visual-category');
    const slideCount =
      context
        ?.querySelector('[data-block-count]')
        ?.getAttribute('data-block-count') || 0;
    if (isVisualCategory && slideCount >= 4) {
      type = 'loop';
    } else {
      type = 'slide';
    }
    return type;
  }
  getSplideOptions() {
    const layout = getBreakpointOptions(this.splide);
    return {
      ...this.options,
      breakpoints: layout,
    };
  }

  improveSVGAccessibility() {
    /*
     * Manually add role and aria-labels to slider arrows. Layout implementation
     * does not allow for adding directly to markup, or to the icons themselves.
     * This is the next-best solution.
     *
     */
    this.arrows = [
      this.module.querySelector('.splide__arrow--prev'),
      this.module.querySelector('.splide__arrow--next'),
    ];

    this.arrows.forEach((arrow) => {
      if (arrow) {
        const svg = arrow.querySelector('svg');
        // Add this check to prevent a TypeError if the SVG is not found
        if (svg) {
          svg.setAttribute('role', 'img');
          svg.setAttribute('aria-label', 'arrow icon');
        }
      }
    });
  }

  observeForAccessibility() {
    /*
     * Observe modules for improving SVG accessibility for sliders that
     * experience mutations after initial page load.
     *
     */
    const target = this.module;
    const observer = new MutationObserver(
      this.improveSVGAccessibility.bind(this)
    );
    observer.observe(target, {
      subtree: true,
      childList: true,
    });
  }
}

/****
 * Education Slider Specific DY Content Updates
 * - Only initializes if there is an active DY campaign for the Education Module Slider.
 * - This is solely to update discount text from DY, and does not control the Splide initialization of the module.
 */
class EducationSlider extends Slider {
  constructor(context) {
    super(context);
    this.module = context;
    if (window.Brooklinen?.educationSlider) {
      this.updateDiscountText();
    }
  }

  updateDiscountText() {
    const { module } = this,
      educationSliderData = window.Brooklinen?.educationSlider[0].cards;
    module.querySelectorAll('.splide__slide').forEach((slide) => {
      const id = slide.getAttribute('href');
      const matchedData = educationSliderData.filter((card) => {
        return card.id == id.replace('#', '');
      });
      if (matchedData[0]) {
        slide.querySelector('.discount-chip__pill').innerHTML =
          matchedData[0].discount_amount;
      }
    });
  }
}

if (document.querySelector('[data-ht-component="education-tiles"]')) {
  pubSub.subscribe('dy:educationSlider:init', () => {
    document
      .querySelectorAll('[data-ht-component="education-tiles"]')
      .forEach((context) => {
        new EducationSlider(context);
      });
  });
}
